import { forwardRef } from "react";
import { Turnstile } from "@marsidev/react-turnstile";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

// Whether the CAPTCHA is configured/active. Forms use this to require a token.
export const CAPTCHA_ENABLED = !!SITE_KEY;

// Renders the Cloudflare Turnstile widget. Pass an `onToken` callback and a ref
// (the ref exposes `.reset()` so the form can reset the widget after submit).
export const CaptchaBox = forwardRef(({ onToken, className = "" }, ref) => {
  if (!SITE_KEY) return null;
  return (
    <div className={`flex justify-center ${className}`} data-testid="captcha-box">
      <Turnstile
        ref={ref}
        siteKey={SITE_KEY}
        options={{ theme: "light" }}
        onSuccess={(token) => onToken(token)}
        onError={() => onToken("")}
        onExpire={() => onToken("")}
      />
    </div>
  );
});
